<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> User Master <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Add User</h1>
            <div class="content-wrap">
                <form [formGroup]="userForm">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="firstName" class="form-label">First Name</label>
                                <input type="text" placeholder="Enter the first name" formControlName="firstName" class="form-control form-input" 
                                id="firstName" [(ngModel)]="user.firstName" [ngClass]="{'is-invalid': submitted && f.firstName.errors }">
                                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                    <div *ngIf="f.firstName.errors.required">First Name is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="lastName" class="form-label">Last Name</label>
                                <input type="text" placeholder="Enter the last name" formControlName="lastName" class="form-control form-input" 
                                id="lastName" [(ngModel)]="user.lastName" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                                <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                    <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="emailId" class="form-label">User Email</label>
                                <input type="text" placeholder="Enter the user email" formControlName="emailId" class="form-control form-input"
                                 id="emailId" [(ngModel)]="user.emailId" [ngClass]="{ 'is-invalid': submitted && f.emailId.invalid}"
                                  [pattern]="emailPattern"  emailId required>
                                 <div *ngIf="submitted &&  f.emailId.invalid" class="invalid-feedback">
                                    <div *ngIf="f.emailId.errors.required">Email Id is required</div>

                                    <div *ngIf="f.emailId.errors.pattern">Email must be a valid email address</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group input-group-lg">
                                <label for="phoneNumber" class="form-label">Phone No.</label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text">+91</span>
                                </div>
                                <input 
                                    type="text" 
                                    placeholder="Enter your phone no." 
                                    formControlName="phoneNumber"
                                    class="form-control form-input"
                                    id="phoneNumber"
                                    [(ngModel)]="user.phoneNumber"
                                    [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }"
                                />
                                <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
                                    <div
                                        *ngIf="f.phoneNumber.errors.pattern || f.phoneNumber.errors.maxlength || f.phoneNumber.errors.minlength">
                                        Phone number must be at least 10 numbers
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="password" class="form-label">Password</label>
                                <input type="password" placeholder="Enter the password" formControlName="password" class="form-control form-input" 
                                id="password" [(ngModel)]="user.password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                                [ngClass]="{ 'is-invalid': submitted && f.password.invalid }" required
                                minlength="6">
                                <div *ngIf="submitted && f.password.invalid" class="invalid-feedback">
                                    <div *ngIf="f.password.errors.required">Password is required</div>
                                    <!-- <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div> -->
                                    <div *ngIf="f.password.errors.pattern"> Must contain at least one number and one
                                        uppercase and lowercase letter, and at least 8 or more characters.</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="confirmPassword" class="form-label">Confirm Password</label>
                                <input type="password" pattern="{{f.password.value }}" placeholder="Confirm the password" formControlName="confirmPassword" class="form-control form-input"
                                 id="confirmPassword" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.invalid }" required>
                                 <div *ngIf="submitted && f.confirmPassword.invalid" class="invalid-feedback">
                                    <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                                    <div *ngIf="f.confirmPassword.errors.pattern"> Password & Confirm Password does not
                                        match.</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="role" class="form-label">Role</label>
                                <select formControlName="roleId" class="form-control form-input" 
                                id="roleId" [(ngModel)]="user.roleId" [ngClass]="{ 'is-invalid': submitted && f.roleId.invalid }">
                                    <option value="undefined" disabled selected> Please select Role </option>
                                    <option *ngFor="let data of roles" [ngValue]="data.id">{{data.rolename}}</option>
                                </select>
                                <div *ngIf="submitted &&  f.emailId.invalid" class="invalid-feedback">
                                    <div *ngIf="f.roleId.errors.required">Role is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="proceed-btn bg-theme" (click)="addUser()">Add User</button>
                    <button class="proceed-btn" (click)="goBack()" >Cancel</button>
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
